import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const tag: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M3.203-7.797A.96.96 0 0 0 3.5-8.5a.94.94 0 0 0-.297-.703A.94.94 0 0 0 2.5-9.5a.96.96 0 0 0-.703.297.92.92 0 0 0-.297.703q0 .41.297.703.293.298.703.297a.92.92 0 0 0 .703-.297M11.843-4a.96.96 0 0 1-.296.703L7.719.547c-.211.195-.45.297-.719.297a.96.96 0 0 1-.703-.297L.719-5.047q-.3-.292-.516-.797A2.4 2.4 0 0 1 0-6.75V-10a.96.96 0 0 1 .297-.703A.96.96 0 0 1 1-11h3.25q.42.002.922.203.498.206.797.5l5.578 5.578c.195.211.297.45.297.719m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11.844",
    width: "11.844",
  }
};

export const tags: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M3.203-7.797A.96.96 0 0 0 3.5-8.5a.94.94 0 0 0-.297-.703A.94.94 0 0 0 2.5-9.5a.96.96 0 0 0-.703.297.92.92 0 0 0-.297.703q0 .41.297.703.293.298.703.297a.92.92 0 0 0 .703-.297M11.843-4a.96.96 0 0 1-.296.703L7.719.547c-.211.195-.45.297-.719.297a.96.96 0 0 1-.703-.297L.719-5.047q-.3-.292-.516-.797A2.4 2.4 0 0 1 0-6.75V-10a.96.96 0 0 1 .297-.703A.96.96 0 0 1 1-11h3.25q.42.002.922.203.498.206.797.5l5.578 5.578c.195.211.297.45.297.719m3 0a.96.96 0 0 1-.296.703L10.719.547c-.211.195-.45.297-.719.297a.95.95 0 0 1-.469-.11 2.3 2.3 0 0 1-.406-.359l3.672-3.672A.96.96 0 0 0 13.094-4c0-.27-.102-.508-.297-.719l-5.578-5.578a2.5 2.5 0 0 0-.797-.5C6.086-10.93 5.782-11 5.5-11h1.75q.42.002.922.203.498.206.797.5l5.578 5.578c.195.211.297.45.297.719m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11.844",
    width: "14.844",
  }
};
